<template>
  <div 
    class="step general" 
    style="margin-left: 100px; padding-right: 140px">
    <div class="general-title">
      <h5>ADD STATUS CONTENT</h5>
    </div>
    <div class="general-tags">
      <span
        v-for="(item, index) in tags"
        :key="index"
        class="general-tag"
        @click.prevent="deleteTag(index)">{{ item.tag }}
      </span>
      <span
        v-show="!show.showInput"
        :class="{'tag-error': errors.tagError}"
        class="tag-add"
        @click="addTag">Click to add tags <span
          v-if="errors.tagError"
          class="tag-error"> - required</span></span>
      <input
        v-show="show.showInput"
        v-model="input.inputText"
        type="text"
        class="general-input"
        @keyup.enter="saveTag">
    </div>
    <div class="general-actions">
      <div class="general-date">
        <p>Created: {{ transformDateCustom(currentDate, 'DD MMM') }}</p>
        <p>Updated: {{ transformDateCustom(currentDate, 'DD MMM') }}</p>
      </div>
      <div class="general-action">
        <div class="delete-action">
          <img :src="getImageUrl('/images/trash.svg')">
        </div>
        <div class="button-action">
          <span @click="saveCurl">save</span>
        </div>
      </div>
    </div>
    <hr>
    <div class="general-body d-flex">
      <div class="items-name">
        <div class="item">
          <p>Forelock</p>
        </div>
        <div class="item">
          <p>Crown</p>
        </div>
        <div class="item">
          <p>Left Side </p>
        </div>
        <div class="item">
          <p>Nape</p>
        </div>
        <div class="item">
          <p>Right Side</p>
        </div>
      </div>
      <div class="items-inputs">
        <div class="item-input d-flex">
          <input
            v-model="forelock"
            type="text">
          <p>in</p>
        </div>
        <div class="item-input d-flex" >
          <input
            v-model="crown"
            type="text">
          <p>in</p>
        </div>
        <div class="item-input d-flex" >
          <input
            v-model="leftSide"
            type="text">
          <p>in</p>
        </div>
        <div class="item-input d-flex" >
          <input
            v-model="nape"
            type="text">
          <p>in</p>
        </div>
        <div class="item-input d-flex">
          <input
            v-model="rightSide"
            type="text">
          <p>in</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import profileMixin from "@/mixins/profileMixin";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  name: "LengthCheck",
  mixins: [profileMixin],

  data() {
    return {
      tags: [],
      currentDate: '',
      forelock: null,
      crown: null,
      leftSide: null,
      nape: null,
      rightSide: null,
      show: {
        showInput: false,
      },
      input: {
        inputText: '',
      },
      errors: {
        tagError: false
      }
    }
  },

  computed: {
    ...mapGetters(['curl']),
  },

  mounted() {
    this.currentDate = moment().format();
    if (this.content === '') {
      this.show.showTextArea = true;
    }

    if (this.title === '') {
      this.show.showTitle = true;
    }
  },

  methods: {
    addTag() {
      this.show.showInput = true;
    },
    saveTag() {
      this.show.showInput = false;
      this.tags.push({tag: this.input.inputText});
      this.input.inputText = '';
    },
    deleteTag(index) {
      this.tags.splice(index, 1);
    },
    saveCurl() {
      if (this.tags.length){
        const saveData = {
          tags: this.tags,
          forelock: this.forelock,
          crown: this.crown,
          leftSide: this.leftSide,
          nape: this.nape,
          rightSide: this.rightSide
        };

        this.$emit('curlData', saveData);
      }
      else{
        this.errors.tagError = true;
      }
    },
  },
}
</script>

<style scoped>
  .tag-error {
    color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/AddCurlStatus/steps/LengthCheck.vue